import Rollbar from 'rollbar'
import { ResponseContractError } from '../contracts/response-contract-error'

const metaContent = (name: string): string | undefined =>
  document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content

const accessToken = metaContent('rollbar-access-token')

const rollbar = accessToken
  ? new Rollbar({
    accessToken,
    environment: metaContent('rollbar-environment'),
    codeVersion: metaContent('rollbar-code-version'),
    captureUncaught: true,
    captureUnhandledRejections: true,
    // Contract failures are reported explicitly with request and validation
    // context before they are rethrown to prevent Inertia from committing them.
    checkIgnore: (isUncaught, args) =>
      isUncaught && args.some((argument) => argument instanceof ResponseContractError),
    captureIp: 'anonymize',
    captureEmail: false,
    captureUsername: false,
  })
  : undefined

export default rollbar
